<script>
import moment from "moment";
import { generateUUID, percentage_format } from "@/utils.js";
import ChartLegend from "@/view/components/consumer_insights/ChartLegend.vue";
export default {
  name: "kpi-chart-single",
  props: [
    "pos_metrics",
    "region_metrics",
    "total_sales_yoy_data",
    "location",
    "view",
    "metrics"
  ],
  components: {
    ChartLegend
  },
  data() {
    return {
      chartOptions: {},
      series: [],
      result: [],
      dates: [],
      show_total_sales: false
    };
  },
  async mounted() {
    // console.log("view", this.view);
    // console.log("metrics", this.metrics);
    // Merge result
    this.result = [];
    let result = [...this.pos_metrics, ...this.region_metrics];
    // console.log("result", result);
    this.result = result;
    let dates = this.result.map(item => item.date);
    // Filter dates
    dates = dates.filter((v, i, a) => a.indexOf(v) === i);
    // console.log("dates", dates);
    this.dates = dates;
    this.dates = this.dates.sort();
    if (this.view.value == "yoy") {
      this.filterTotalSalesData();
    }
    setTimeout(() => {
      this.onSearch();
    }, 1000);
  },
  computed: {
    subtitle() {
      return `${this.view.text}`;
    },
    chartId() {
      return `chart_${generateUUID()}`;
    }
  },
  watch:{
    "location"(){
      this.series = []; // everytime location changes - this should clear so it run onsearch button
    },
  },
  methods: {
    filterTotalSalesData() {
      // console.log(this.total_sales_yoy_data);
      let dates = this.total_sales_yoy_data.map(item => item.date);
      // Filter dates
      // dates = dates.filter((v, i, a) => a.indexOf(v) === i);
      // // console.log("this.dates", this.dates);
      // // console.log("dates", dates);
      // for (let i = 0; i < dates.length; i++) {
      //   let date = dates[i];
      //   if (this.dates.indexOf(date) === -1) {
      //     this.dates.push(date);
      //   }
      // }
      // this.dates = this.dates.sort();
      // console.log("updated this.dates", this.dates);
    },
    async onSearch() {
      // this.result = [];
      // let result = [...this.pos_metrics, ...this.region_metrics];
      // this.result = result;
      // console.log("this.result", this.result);
      if (this.result && this.result.length > 0) {
        // Get all dates
        // let dates = this.result.map(item => item.date);
        // Filter dates
        // dates = dates.filter((v, i, a) => a.indexOf(v) === i);
        // console.log("dates", dates);
        // dates = dates.reverse();
        // dates = dates.sort();
        let categories = this.dates;
        // console.log("categories", categories);
        let series = [];
        for (let i = 0; i < this.metrics.length; i++) {
          let baseline = this.metrics[i];
          if (baseline.value !== "sales_yoy") {
            // console.log("baseline", baseline);
            let obj = {
              name: baseline.text,
              data: this.getData(baseline),
              type: "area"
            };
            // Multiple Y Axis
            // if (baseline.text == "Restaurant Discretionary Spend") {
            //   obj.type = "column";
            // }
            series.push(obj);
          }
          if (baseline.value === "sales_yoy") {
            this.show_total_sales = true;
          }
        }
        // console.log("series", series);
        if (this.view.value == "yoy") {
          this.setTotalSalesSeries(series);
        } else {
          this.series = series;
        }
        this.chartOptions = {
          chart: {
            height: 350,
            type: "line",
            stacked: false,
            toolbar: {
              show: true,
              tools: {
                download:
                  '<i class="flaticon2-download-2" style="color:gray;"></i>',
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset:
                  '<i class="flaticon2-refresh-button" style="color:gray;"></i>',
                customIcons: []
              }
            },
            events: {
              updated: () => {
                this.setLegendTooltip();
              },
              mounted: () => {
                this.setLegendTooltip();
              }
            }
          },
          colors: [
            "#008FFB",
            "#4CAF50",
            "#FEB019",
            "#FF4560",
            "#F9C80E",
            "#5A2A27"
          ],
          dataLabels: {
            enabled: false
          },
          stroke: {
            width: [1, 1, 4]
          },
          title: {
            text: `${this.location.name ? this.location.name : ""} ${
              this.location.full_address ? this.location.full_address : ""
            }`,
            align: "left"
          },
          subtitle: {
            text: this.subtitle,
            align: "left"
          },
          xaxis: {
            type: "datetime",
            categories: categories,
            labels: {
              formatter: function (value, timestamp) {
                return moment(value).format('MMM-DD-YYYY')
              } 
            }
          },
          yaxis: {
            show: true,
            showAlways: true,
            labels: {
              show: true,
              formatter: function(val) {
                return `${percentage_format(val)}`;
              }
            }
          },
          // Multiple Y Axis
          // yaxis: [
          //   {
          //     axisTicks: {
          //       show: true
          //     },
          //     axisBorder: {
          //       show: true
          //     },
          //     tooltip: {
          //       enabled: true
          //     },
          //     labels: {
          //       show: true,
          //       formatter: function(val) {
          //         return `${percentage_format(val)}`;
          //       }
          //     }
          //   },
          //   {
          //     seriesName: "Restaurant Discretionary Spend",
          //     opposite: true,
          //     axisTicks: {
          //       show: true
          //     },
          //     axisBorder: {
          //       show: true
          //     },
          //     title: {
          //       text: "Restaurant Discretionary Spend"
          //     },
          //     labels: {
          //       show: true,
          //       formatter: function(val) {
          //         return `${percentage_format(val)}`;
          //       }
          //     }
          //   },
          //   {
          //     show: false,
          //     seriesName: "Restaurant Share of Wallet",
          //     labels: {
          //       show: true,
          //       formatter: function(val) {
          //         return `${percentage_format(val)}`;
          //       }
          //     }
          //   },
          //   {
          //     show: false,
          //     seriesName: "Total Share of Wallet",
          //     labels: {
          //       show: true,
          //       formatter: function(val) {
          //         return `${percentage_format(val)}`;
          //       }
          //     }
          //   },
          //   {
          //     show: false,
          //     seriesName: "Restaurant Market Share",
          //     labels: {
          //       show: true,
          //       formatter: function(val) {
          //         return `${percentage_format(val)}`;
          //       }
          //     }
          //   },
          //   {
          //     show: false,
          //     seriesName: "Total Sales",
          //     labels: {
          //       show: true,
          //       formatter: function(val) {
          //         return `${percentage_format(val)}`;
          //       }
          //     }
          //   }
          // ],
          tooltip: {
            x: {
              format: "dd/MM/yy HH:mm"
            }
          }
        };
      }
    },
    setTotalSalesSeries(series) {
      this.series = [];
      let temp_series = series;
      // console.log("dates", this.dates);
      let data = [];
      for (let i = 0; i < this.dates.length; i++) {
        let d = this.dates[i];
        let total = 0;
        let filter_results = this.total_sales_yoy_data.filter(
          obj => obj.date == d
        );
        // console.log("filter_results", filter_results);
        for (let j = 0; j < filter_results.length; j++) {
          let item = filter_results[j];
          total = total + (item.value ? parseFloat(item.value) : 0);
        }
        data.push(total);
      }
      // console.log(data);
      // if (this.show_total_sales) {
      //   // console.log("show_total_sales", this.show_total_sales);
      //   temp_series.push({
      //     name: "Total Sales",
      //     data: data,
      //     type: "area"
      //   });
      // }
      this.series = temp_series;
    },
    getData(metric) {
      // console.log("view", this.view);
      // console.log("metric", metric);
      let search_key = null;
      if (this.view.value === "yoy") {
        search_key = metric.yoy;
      } else if(this.view.value == 2){
        search_key = metric.yo2y;
      } else {
        search_key = metric.value;
      }
      let data = [];
      for (let i = 0; i < this.dates.length; i++) {
        let d = this.dates[i];
        let filter_results = this.result.filter(obj => obj.date == d);
        let count = 0;
        
        for (let j = 0; j < filter_results.length; j++) {
          let object1 = filter_results[j];
          for (const [key, value] of Object.entries(object1)) {
            if (search_key == key) {
              count = value && value !== null ?  parseFloat(value) : 0;
              // count =  count + parseFloat(value);
              break;
            }
          }
        }
        data.push(count);
      }
      return data;
    },
    setLegendTooltip() {
      // console.log("this.metrics", this.metrics);
      if (this.metrics && this.metrics.length > 0) {
        for (let i = 0; i < this.metrics.length; i++) {
          let idx = i + 1;
          let id = `.apexcharts-legend-series[rel="${idx}"]`;
          let element = document.querySelectorAll(`${id}`);
          // console.log("element", element[0]);
          if (element && element[0]) {
            element[0].classList.add("apexcharts-legend-default-overflow");
          }
        }
        var boxElem = document.querySelectorAll(
          ".apexcharts-legend-default-overflow"
        );
        boxElem.forEach(item => {
          item.addEventListener("mouseenter", mouseenter);
          item.addEventListener("mouseleave", mouseleave);
        });
      }
      function mouseenter(event) {
        let element = event.target;
        let seriesname = element.getAttribute("seriesname");
        // console.log("seriesname", seriesname);
        let tooltip = document.getElementById(`tooltip_${seriesname}`);
        tooltip.style.display = "block";
      }
      function mouseleave(event) {
        let element = event.target;
        let seriesname = element.getAttribute("seriesname");
        // console.log("seriesname", seriesname);
        let tooltip = document.getElementById(`tooltip_${seriesname}`);
        tooltip.style.display = "none";
      }
    }
  }
};
</script>

<template>
  <div>
    <v-card flat class="mb-20">
      <apexchart
        :options="chartOptions"
        :series="series"
        type="area"
        height="300"
        :id="chartId"
        style="position:relative; z-index: 1;"
      ></apexchart>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip_TotalxFoodxSpend"
        style="display: none;"
      >
        <v-card-text>
          <chart-legend id="TotalxFoodxSpend"></chart-legend>
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip_TotalxDiscretionaryxSpend"
        style="display: none;"
      >
        <v-card-text>
          <chart-legend id="TotalxDiscretionaryxSpend"></chart-legend>
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip_SharexofxStomach"
        style="display: none;"
      >
        <v-card-text>
          <chart-legend id="SharexofxStomach"></chart-legend>
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip_RestaurantxDiscretionaryxSpend"
        style="display: none;"
      >
        <v-card-text>
          <chart-legend id="RestaurantxDiscretionaryxSpend"></chart-legend>
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip_RestaurantxSharexofxWallet"
        style="display: none;"
      >
        <v-card-text>
          <chart-legend id="RestaurantxSharexofxWallet"></chart-legend>
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip_TotalxSharexofxWallet"
        style="display: none;"
      >
        <v-card-text>
          <chart-legend id="TotalxSharexofxWallet"></chart-legend>
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip_RestaurantxMarketxShare"
        style="display: none;"
      >
        <v-card-text>
          <chart-legend id="RestaurantxMarketxShare"></chart-legend>
        </v-card-text>
      </v-card>
      <v-card
        color="#eeeeee"
        flat
        id="tooltip_TotalxSales"
        style="display: none;"
      >
        <v-card-text>
          <chart-legend id="TotalxSales"></chart-legend>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
</template>
